import React from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { API } from 'aws-amplify';
import { Box, Button } from '@mui/material';
import { makeStyles } from '@mui/styles';

import RenderIf from '../../../../renderIf';
import useQuestion from './useQuestion';

const useStyles = makeStyles(() => ({
    sigCanvas: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
    },
}));

const Signature = (props) => {
    const { question, appInstId, disabled, readOnly } = props;

    const { chosenVal } = useQuestion(question);

    const [pngUrl, setPngUrl] = React.useState();

    const classes = useStyles();
    const sigPadRef = React.useRef();

    const initialize = async () => {
        if (chosenVal) {
            let presignedPng = await API.get('ShipyardAPI', `/application/${appInstId}/answer/${question.id}/signature`);
            setPngUrl(presignedPng.location);
        }
    };

    React.useEffect(() => {
        initialize();
    }, []);

    //#TODO TechDebt - This Component has only had a readOnly state implemented so far. It's full functionality will be implemented after the TSB project.
    return (
        <Box>
            <Box
                sx={{
                    width: '500px',
                    aspectRatio: '10/3',
                    border: '2px solid black',
                    borderRadius: '4px',
                    position: 'relative',
                    maxWidth: '100%',
                }}
            >
                <RenderIf isTrue={chosenVal === undefined}>
                    <SignatureCanvas
                        ref={sigPadRef}
                        canvasProps={{ className: classes.sigCanvas }}
                    />
                </RenderIf>

                <RenderIf isTrue={chosenVal && pngUrl}>
                    <Box
                        component="img"
                        alt="signature"
                        src={pngUrl}
                        sx={{ height: '100%', width: '100%', objectFit: 'contain' }}
                    />
                </RenderIf>
            </Box>

            <Box
                sx={{
                    marginTop: '1rem',
                    width: '500px',
                    display: readOnly ? 'none' : 'flex',
                    justifyContent: 'space-between',
                }}
            >
                <Button
                    variant="contained"
                    onClick={() => sigPadRef.current?.clear()}
                    disabled={disabled}
                >
                    Clear signature
                </Button>

                <Button
                    variant="contained"
                    disabled={disabled}
                >
                    Sign
                </Button>
            </Box>
        </Box>
    );
};

export default Signature;
